import React, { useState } from "react";
import styles from "./styles.module.scss";
import SearchBar from "app/components/inputs/SearchBar";
import Button from "app/components/Button/ButtonVariant";
import CheckBox from "app/components/inputs/CheckBox";
import { useHistory } from "react-router-dom";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { searchAll } from "app/actions/searchAll";
import { RootState } from "typedefs";
import { SearchCard } from "./components/SearchCard/SearchCard";
import { SearchAllModel } from "app/models/SearchAllModel";
import { useTranslation } from "react-i18next";
import useQuery from "app/utils/hooks/useQuery";

const Search = () => {
  const { t } = useTranslation();
  const queryParam = useQuery();
  const [searchReplies, setSearchReplies] = useState(false);
  const history = useHistory();
  const searchQuery = queryParam.get("q");
  const [searchField, setSearchField] = useState(searchQuery || "");
  const dispatch = useDispatch();
  const data = useSelector(
    (state: RootState) => state.searchAll.successSearch,
    shallowEqual,
  );

  const isLoading = useSelector(
    (state: RootState) => state.searchAll.pendingSearch,
    shallowEqual,
  );

  const searchHandler = () => {
    history.push(`/search?q=${searchField}`);
    dispatch(searchAll(searchField, searchReplies));
  };

  return (
    <>
      <div className={styles.search_container}>
        <h1>{t("Search")}</h1>
        <div className={styles.search_wrapper}>
          <SearchBar
            className={styles.search_input}
            value={searchField}
            onChange={(val) => setSearchField(val)}
            onKeyDown={searchHandler}
          />
          <Button
            title={t("Search")}
            buttonType="primary"
            onClickFunc={searchHandler}
            buttonStyles={styles.search_button}
          />
        </div>
        <CheckBox
          label={t("Search replies")}
          className={styles.checkbox_input}
          checked={searchReplies}
          onChange={() => setSearchReplies((prev) => !prev)}
        />

        <div className={styles.search_results_list}>
          {data &&
            !isLoading &&
            data.map((searchVal: SearchAllModel) => {
              if (!searchVal?.id) {
                return null;
              }

              return (
                <SearchCard
                  searchField={searchField}
                  searchValue={searchVal}
                  key={searchVal.id}
                />
              );
            })}
        </div>
      </div>
      {!data.length && !isLoading && (
        <h2 className={styles.status}>Nothing found</h2>
      )}
      {isLoading && <h2 className={styles.status}>Loading...</h2>}
    </>
  );
};

export { Search };
